import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCode, FiCpu, FiGlobe } = FiIcons;

export default function HowItWorks() {
  const steps = [
    { title: "Do work", description: "Build, code, create—whatever you do best. Work naturally.", icon: FiCode },
    { title: "We document", description: "AI witnesses your sessions and reconstructs them into stories.", icon: FiCpu },
    { title: "Page updates", description: "Your work gets a shareable home that grows over time.", icon: FiGlobe }
  ];

  return (
    <section className="py-24 relative overflow-hidden bg-slate-950/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-black text-white mb-6 tracking-tight uppercase italic">Zero-friction documentation</h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">Real work happens elsewhere. We just make the invisible visible.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-card p-10 group hover:border-primary/50 transition-all"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-primary to-blue-600 rounded-2xl flex items-center justify-center mb-8 shadow-lg shadow-primary/20 group-hover:scale-110 transition-transform">
                <SafeIcon icon={step.icon} className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-2xl font-black text-white mb-4 italic uppercase tracking-tighter">
                {step.title}
              </h3>
              <p className="text-slate-400 leading-relaxed font-medium">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}